import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import { Login } from "./Components/Login/Login";
import PersistLogin from "./Components/Login/PersistLogin";
import { RequireAuth } from "./Components/Login/RequireAuth";
import ProtectedRoute from "./Components/Protected/ProtectedRoute";
import { LEVELS } from "./config/levels";
import { selectCurrentToken } from "./redux-toolkit/features/auth/authSlice";
import { LOGOUT_BROADCAST_KEY } from "./constants/authStorage";
import { persistor } from "./redux-toolkit/store";
import { SESSION_REPLACED_EVENT, teardownSocket } from "./utils/socket";
import { Account } from "./Components/Account/Account";
import { AdminDashboard } from "./Components/Admin/Dashboard/AdminDashboard";
import { EditBooks } from "./Components/Admin/My Workspace/Edit books/EditBooks";
import { EditCourses } from "./Components/Admin/My Workspace/Edit courses/EditCourses";
import { Workspace } from "./Components/Admin/My Workspace/Workspace";
import { Reports } from "./Components/Admin/Reports/Reports";
import { EmployeeActivity as AdminEmployeeActivity } from "./Components/Admin/Reports/Reports Detailed/Employee Activity/EmployeeActivity";
import { CompanyWiseBreakdown as AdminCompanyWiseBreakdown } from "./Components/Admin/Reports/Reports Detailed/Company Wise Breakdown/CompanyWiseBreakdown";
import { OrgBookSummary as AdminOrgBookSummary } from "./Components/Admin/Reports/Reports Detailed/Org Book Summary/OrgBookSummary";
import { TaskDetailed } from "./Components/Admin/Task Verification/Task Detailed/TaskDetailed";
import { TimeTrialDetailed } from "./Components/Admin/Task Verification/Task Detailed/TimeTrialDetailed";
import { TaskVerification } from "./Components/Admin/Task Verification/TaskVerification";
import { Books } from "./Components/Books/Books";
import { Home } from "./Components/Books/Home";
import { Levels } from "./Components/Books/Levels/Levels";
import { TimeTrailsTask } from "./Components/TimeTrails/TimeTrailsTask";
import EmployeeLayout from "./Components/Layout/Book/EmployeLayout";
import MainBookLayout from "./Components/Layout/Book/MainBookLayout";
import MainAdminLayout from "./Components/Layout/Lms/Sidebar/MainAdminLayout";
// import MyActivity from "./Components/MyActivity/MyActivity";
import MyActivity2 from "./Components/MyActivity2";
import { Coursedetail } from "./Components/Mycourses/Course/Coursedetail";
import { NotAllowed } from "./Components/Not allowed/NotAllowed";
import { PrivateRoutes } from "./Components/Routes HOC/PrivateRoutes";
import { RestrictedRoutes } from "./Components/Routes HOC/RestrictedRoutes";
import { Access } from "./Components/Super Admin/Manage Organization/Access/Access";
import { Credentials } from "./Components/Super Admin/Manage Organization/Credentials/Credentials";
import { CompanyBooks } from "./Components/Super Admin/Manage Organization/Company/Company books/CompanyBooks";
import { Companies } from "./Components/Super Admin/Manage Organization/Company/Companies";
import { Employee } from "./Components/Super Admin/Manage Organization/Employee/Employee";
import { EmployeeActivityPage } from "./Components/Super Admin/Manage Organization/Employee/Activity/EmployeeActivityPage";
import { OrganizationalWorkspace } from "./Components/Super Admin/Manage Quest/OrganizationalWorkspace/OrganizationalWorkspace";
import { CompanyAdminTaskVerification } from "./Components/Super Admin/Manage Quest/Hod Task Verification/CompanyAdminTaskVerification";
import { ManageQuest } from "./Components/Super Admin/Manage Quest/ManageQuest";
import { Themes } from "./Components/Super Admin/Manage Quest/Themes/Themes";
import { SaDashboard } from "./Components/Super Admin/Super Admin Dashboard/SaDashboard";
import { BookSummary } from "./Components/Super Admin/Super Admin Reports/Reports detailed Sa/Book Summary/BookSummary";
import { CustomReport } from "./Components/Super Admin/Super Admin Reports/Reports detailed Sa/Custom Reports/CustomReport";
import { UserStatistic } from "./Components/Super Admin/Super Admin Reports/Reports detailed Sa/User Statistics/UserStatistic";
import { CompanyWiseBreakdown } from "./Components/Super Admin/Super Admin Reports/Reports detailed Sa/Company Wise Breakdown/CompanyWiseBreakdown";
import { OrgBookSummary } from "./Components/Super Admin/Super Admin Reports/Reports detailed Sa/Org Book Summary/OrgBookSummary";
import { EmployeeSequentialProgress } from "./Components/Super Admin/Super Admin Reports/Reports detailed Sa/Employee Sequential Progress/EmployeeSequentialProgress";
import { UserSummary } from "./Components/Super Admin/Super Admin Reports/Reports detailed Sa/User Summary/UserSummary";
import { EmployeeActivity } from "./Components/Super Admin/Super Admin Reports/Reports detailed Sa/Employee Activity/EmployeeActivity";
import { AdminActivityLog } from "./Components/Super Admin/Super Admin Reports/Reports detailed Sa/Admin Activity Log/AdminActivityLog";
import {
  ItOnlyRoute,
  ItUsers,
  PlatformSettings,
} from "./Components/Super Admin/PlatformSettings/PlatformSettings";
import { PromotionsReport } from "./Components/Super Admin/Super Admin Reports/Reports detailed Sa/Promotions/PromotionsReport";
import { SaReports } from "./Components/Super Admin/Super Admin Reports/SaReports";
import { useGetInitialAppliedThemeQuery } from "./redux-toolkit/features/theme/themeApiSlice";
import AllNotifications from "./Components/Notifications/AllNotifications";
import NotificationSetting from "./Components/Notifications/NotificationSetting";
import Rewards from "./Components/Super Admin/Rewards/Rewards";
import RedeemStatus from "./Components/Super Admin/Rewards/RedeemStatus";
import { Promotions } from "./Components/Super Admin/Promotions/Promotions";
import { PromotionsHistory } from "./Components/Super Admin/Promotions/PromotionsHistory";
import { PromotionEventDetail } from "./Components/Super Admin/Promotions/PromotionEventDetail";
import { EmailTemplates } from "./Components/Super Admin/Promotions/EmailTemplates";
import { EmailTemplateEditor } from "./Components/Super Admin/Promotions/EmailTemplateEditor";
import { PromotionInviteResponse } from "./Components/Promotions/PromotionInviteResponse";
import RewardsEmp from "./Components/Rewards/RewardsEmp";
import Cart from "./Components/Rewards/Cart/Cart";
import { TourModal } from "./Components/UI/Tour/TourModal";
import Joyride from "react-joyride";
import { useLocation } from "react-router-dom";
import Thankyou from "./Components/Rewards/Cart/Thankyou";
import { Layout as LegalPagesLayout } from "./Components/LegalPages/index.jsx";
import { PrivacyPolicy } from "./Components/LegalPages/PrivacyPolicy/PrivacyPolicy";
import { TermsOfService } from "./Components/LegalPages/TermsAndConditions/TermsAndConditions";

import {
  useGetCompletedAlphaScreensQuery,
  useMarkAlphaScreenCompleteMutation,
} from "./redux-toolkit/features/auth/authApiSlice";
import {
  setStep,
  setTourOpen,
  setTourActive,
  setFeedbackOpen,
  clearManualTourReplay,
} from "./redux-toolkit/features/theme/themeSlice";
import Feedback from "./Components/UI/Feedback/Feedback";
import FeedbackModal from "./Components/UI/Feedback/FeedbackModal";
import DevTools from "./Components/UI/DevTools/DevTools";
import { showDevTools } from "./utils/apiBaseUrl";
import { useAlert } from "./hooks/useAlert";
import SessionTimer from "./Components/Util/SessionTimer/SessionTimer";
import { ViewBook } from "./Components/Admin/My Workspace/View Book/ViewBook";
import { Respassword } from "./Components/Login/Respassword";

const homePage = [
  {
    target: ".my-first-step",
    content: "This is my awesome feature!",
  },
  {
    target: ".step21",
    title: "Explore Different Books!",
    content: "Your books are categorised under Organization and Company.",
  },
  {
    target: ".step22",
    title: "The Quest",
    content:
      "Get ready to start your journey on The Quest! Each Book has levels and tasks to explore. ",
  },
  {
    target: "#step23",
    title: "Rewards",
    content: "Redeem your points here.",
  },
  {
    target: "#step24",
    title: "My Activity",
    content: "View all your progress & achievements.",
  },
  {
    target: ".step25",
    title: "Notifications ",
    content:
      "Here you can see all triggers generated by your activity on the platform. Overall points, badges, and Rewards collected.",
  },
];

const adminTour = [
  {
    target: "#step0",
    title: "kickstart",
    content:
      "The dashboard provides an at-a-glance view to the important metrics, insights of the activities within an organization. Each time you sign-in, Analytics will surface data from all the companies.",
  },
  {
    target: "#step1",
    title: "Dashboard",
    content:
      "If you have the admin permissions, here you can see an overview of information about your users and their engagement on the platform. ",
  },
  {
    target: "#step2",
    title: "My Workspace",
    content:
      "Get ready to create an engagement platform. Create your books and courses here. You can gamify by adding levels and tasks to each book.",
  },

  {
    target: "#step3",
    title: "Manage Company",
    content:
      "The admin responsible for overseeing the company's tasks is informed about the completed task and initiates the review process here.",
  },
  {
    target: "#step4",
    title: "Reports",
    content:
      "From this section, you can review detailed information on employee activity, company breakdown, and organisation book progress for your companies.",
  },
  // {
  //   target: '#step9',
  //   title: 'Notifications ',
  //   content:
  //     'Here you can see all the triggers generated by user activities. Requests to approve any tasks or details about the team points.',
  // },
];

const superAdminTour = [
  {
    target: "#step0",
    title: "kickstart",
    content:
      "The dashboard provides an at-a-glance view to the important metrics, insights of the activities within an organization. Each time you sign-in, Analytics will surface data from all the companies.",
  },
  {
    target: "#step1",
    title: "Dashboard",
    content:
      "The dashboard provides an at-a-glance view to the important metrics, insights of the activities within an organization. Each time you sign-in, Analytics will surface data from all the companies.",
  },
  {
    target: "#step3",
    title: "Manage Quest",
    content:
      "Manage the books with edit and create functionality. Any activity by users under these books will be verified under Task verification. To centralise the platform, explore Themes.",
  },

  {
    target: "#step2",
    title: "Manage Organization",
    content:
      "Review and edit your users, companies, their permissions and more.",
  },
  {
    target: "#step4",
    title: "Reports",
    content:
      "Gain a deeper understanding of your data available via dashboard (users, books, rewards). Click Reports and export the required details.",
  },
  {
    target: "#step5",
    title: "Rewards",
    content: "Create categories here and add products under them.",
  },
];

function App() {
  const token = useSelector(selectCurrentToken);
  const user = useSelector((state) => state.auth.user);
  const theme = useSelector((state) => state.theme);
  const location = useLocation();
  const dispatch = useDispatch();
  const { displayAlert } = useAlert();

  const [markAlphaScreenComplete] = useMarkAlphaScreenCompleteMutation();
  const handleFeedbackOpen = () => {
    dispatch(setFeedbackOpen(true));
  };

  const feedbackOpenClose = () => {
    dispatch(setFeedbackOpen(false));
  };

  const handleTourStart = () => {
    dispatch(setTourOpen(false));
    dispatch(setTourActive(true));
  };
  const handleTourClose = () => {
    dispatch(setTourOpen(false));
  };

  const handleTourEnd = () => {
    dispatch(setTourActive(false));
    markScreenComplete();
    // Clear steps to prevent markers from showing
    dispatch(setStep([]));
  };
  const { data, refetch } = useGetInitialAppliedThemeQuery(undefined, {
    refetchOnMountOrArgChange: true,
    skip: !token,
  });

  const { data: alphaScreens, refetch: alphaRefetch } =
    useGetCompletedAlphaScreensQuery(undefined, {
      refetchOnMountOrArgChange: true,
      skip: !token,
    });

  useEffect(() => {
    if (!token) return;
    Promise.resolve(refetch()).catch(() => {});
  }, [token, refetch]);

  // When another tab logs out, mirror that here (storage events fire only in other tabs).
  useEffect(() => {
    const clearLocalSessionAndGoToLogin = () => {
      teardownSocket();
      persistor.pause();
      localStorage.clear();
      sessionStorage.clear();
      window.location.assign("/login");
    };

    const onStorage = (event) => {
      if (event.key !== LOGOUT_BROADCAST_KEY || event.newValue == null) return;
      clearLocalSessionAndGoToLogin();
    };

    // Newest tab/window took over this user's sole socket connection.
    const onSessionReplaced = () => {
      clearLocalSessionAndGoToLogin();
    };

    window.addEventListener("storage", onStorage);
    window.addEventListener(SESSION_REPLACED_EVENT, onSessionReplaced);
    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener(SESSION_REPLACED_EVENT, onSessionReplaced);
    };
  }, []);

  const handleLocalStorageAScreenState = async (screen) => {
    let existingScreens =
      JSON.parse(localStorage.getItem("alpha_screens")) || [];
    if (!existingScreens.includes(screen)) {
      let newArray = [...existingScreens, screen];
      localStorage.setItem("alpha_screens", JSON.stringify(newArray));
      await markAlphaScreenComplete({ screen });
    }
  };

  // Alpha screens / auto tours are disabled; manual tour replay still works.
  const showScreen = (_screen) => false;

  const getTourForPath = (pathName) => {
    switch (pathName) {
      case "/quest":
        return { steps: homePage, screen: "HOME" };
      case "/admin":
        return { steps: adminTour, screen: "ADMIN" };
      case "/super-admin":
        return { steps: superAdminTour, screen: "SUPERADMIN" };
      default:
        return null;
    }
  };

  const shouldShowSteps = () => {
    const tourConfig = getTourForPath(location.pathname);
    if (!tourConfig) return;

    if (showScreen(tourConfig.screen)) {
      dispatch(setStep(tourConfig.steps));
      if (tourConfig.screen === "HOME") {
        if (!theme.tourActive) dispatch(setTourOpen(true));
      } else {
        dispatch(setTourActive(true));
      }
    }
  };
  const markScreenComplete = async (completedScreens) => {
    if (theme?.step[1]?.title === "Switch View") {
      await handleLocalStorageAScreenState("PROFILE_DD");
      // Clear steps after marking PROFILE_DD complete to hide marker
      dispatch(setStep([]));
      dispatch(setTourActive(false));
      return;
    }

    switch (location.pathname) {
      case "/quest":
        await handleLocalStorageAScreenState("HOME");
        break;
      case "/admin":
        await handleLocalStorageAScreenState("ADMIN");
        break;
      case "/super-admin":
        await handleLocalStorageAScreenState("SUPERADMIN");
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (!token) return;
    Promise.resolve(alphaRefetch()).catch(() => {});
  }, [user, token, alphaRefetch]);

  useEffect(() => {
    if (!alphaScreens || !alphaScreens?.data) return;
    let timer = setTimeout(() => {
      shouldShowSteps();
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  }, [location.pathname, alphaScreens, user, token]);

  useEffect(() => {
    if (!theme.manualTourReplayRequest) return;
    if (!user || !token) return;

    const requestedPath = theme.manualTourReplayRequest.context;
    const tourConfig = getTourForPath(requestedPath);

    if (tourConfig) {
      dispatch(setTourOpen(false));
      dispatch(setStep(tourConfig.steps));
      dispatch(setTourActive(true));
    }

    dispatch(clearManualTourReplay());
  }, [theme.manualTourReplayRequest, user, token, dispatch]);

  const handleFeedbackNotification = (data) => {
    if (data?.result) {
      displayAlert({
        open: true,
        message: "Successfully submitted feedback",
        type: "success",
        timeout: "2000",
      });
    } else {
      displayAlert({
        open: true,
        message: "Something went wrong! Try after sometime",
        type: "error",
        timeout: "2000",
      });
    }
  };

  return (
    <div className={data?.data?.mode === "dark" ? "" : "dark"}>
      <TourModal
        onSkipClick={handleTourEnd}
        handleTourClose={handleTourClose}
        tourOpen={theme.tourOpen}
        mode={data?.data?.mode}
        handleTourStart={handleTourStart}
      />
      {token &&
        user != null &&
        theme?.sessionTime < 25 &&
        !user?.hasGivenFeedback && (
          <SessionTimer
            user={user}
            token={token}
            sessionTime={theme?.sessionTime}
          />
        )}

      {(showDevTools || (token && user != null)) && (
        <div className="floating-dock">
          {showDevTools && <DevTools />}
          {token && user != null && (
            <Feedback
              hasGivenFeedback={user?.hasGivenFeedback}
              sessionTime={theme?.sessionTime}
              handleFeedbackOpen={handleFeedbackOpen}
            />
          )}
        </div>
      )}

      <FeedbackModal
        userName={user?.fname + " " + user?.lname}
        page={location.pathname}
        userEmail={user?.email}
        userRole={user?.role}
        isOpen={theme.feedbackOpen}
        onClose={feedbackOpenClose}
        onSuccess={(data) => handleFeedbackNotification(data)}
        onError={console.log}
      />

      <Routes>
        {/* PUBLIC ROUTES */}
        <Route element={<LegalPagesLayout />}>
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsOfService />} />
        </Route>

        <Route
          path="/login"
          element={<Login />}
        />
        <Route path="/auth" element={<RequireAuth />} />
        <Route path="/forgot-password" element={<Login />} />
        <Route path="/send-mail" element={<Login />} />
        <Route path="/reset-password/:id/:token" element={<Respassword />} />

        <Route
          path="*"
          element={
            token && user != null ? (
              <Navigate to={user?.role === "IT" ? "/super-admin" : "quest"} />
            ) : (
              <Navigate to={"/login"} />
            )
          }
        />

        {/* END OF PUBLIC ROUTES */}
        {/* PRIVATE ROUTES WITH AUTH */}
        <Route element={<PersistLogin />}>
          <Route
            element={
              <ProtectedRoute allowedLevels={[...Object.values(LEVELS)]} />
            }
          >
            {/* <Route path="lms" element={<MainLmsLayout />}> */}
            {/* <Route path="dashboard" element={<Main />} />
              <Route path="courses" element={<Courses />} />
              <Route path="calendar" element={<Calendar />} />
              <Route path="library" element={<Library />} /> */}
            {/* <Route path="library/:_id" element={<LibCompany />} />
              <Route path="forums" element={<Forums />} />
              <Route path="leaderboard" element={<Leaderboard />} /> */}
            {/* </Route> */}
            <Route path="restricted" element={<NotAllowed />} />

            {/* quest routes   */}
            <Route
              path="quest"
              element={
                user?.role === "IT" ? (
                  <Navigate to="/super-admin" replace />
                ) : (
                  <MainBookLayout />
                )
              }
            >
              <Route path="books/:bookId" element={<Books />} />
              <Route
                path="books/:bookId/levels/:levelId"
                element={<Levels />}
              />
              <Route
                path=":bookName/:bookId/:levelName/:levelId/task/:taskId/course/:courseId"
                element={<Coursedetail />}
              />
            </Route>

            {/* Employee routes   */}
            <Route
              path="quest"
              element={
                user?.role === "IT" ? (
                  <Navigate to="/super-admin" replace />
                ) : (
                  <EmployeeLayout />
                )
              }
            >
              <Route
                path=""
                element={
                  <Home
                    wheelBgColor={data?.data.wheelBgColor}
                    wheelColors={data?.data.wheelColors}
                    themeCardImage={data?.data.themeCardImage}
                    user={user}
                  />
                }
              />
              <Route path="rewards" element={<RewardsEmp />} />
              <Route path="cart" element={<Cart />} />
              <Route path="thank-you" element={<Thankyou />} />
              <Route
                path="promotions/invite/:promotionId"
                element={<PromotionInviteResponse />}
              />

              {/* Time Trails Routes */}
              <Route path="time-trails" element={<TimeTrailsTask />} />

              <Route path="account" element={<Account />} />
              {/* <Route path="my-activity" element={<MyActivity />} /> */}
              <Route path="my-activity" element={<MyActivity2 />} />
              <Route path="notifications" element={<AllNotifications />} />
              <Route
                path="notifications/settings"
                element={<NotificationSetting />}
              />
            </Route>
          </Route>

          {/* Admin routes */}

          <Route
            element={
              <PrivateRoutes
                permissions={["ADMIN", "CUSTOM_ROLE"]}
                allowedLevels={true}
              />
            }
          >
            <Route path="admin" element={<MainAdminLayout isAdmin />}>
              {/* ADMIN Dashboard  */}
              <Route path="" element={<AdminDashboard />} />
              <Route
                path="manage-company/employee/:company"
                element={<Employee isAdmin />}
              />
              <Route
                path="manage-company/employee/:company/:employeeId/activity"
                element={<EmployeeActivityPage />}
              />
              {/* Task verifications */}
              <Route element={<RestrictedRoutes access={["ADMIN_TASK_VER"]} />}>
                <Route
                  path="manage-company/task-verification"
                  element={<TaskVerification />}
                />
                <Route
                  path="manage-company/task-verification/:_id"
                  element={<TaskDetailed />}
                />
              </Route>

              {/* My workspace || Admin dashboard will only be available if course or books access is given */}
              <Route
                element={
                  <RestrictedRoutes access={["ADMIN_COURSES", "ADMIN_BOOKS"]} />
                }
              >
                <Route path="my-workspace" element={<Workspace />} />

                <Route
                  path="my-workspace/edit-books/:_id"
                  element={<EditBooks isAdmin />}
                />
                <Route
                  path="my-workspace/view-books/:_id"
                  element={<EditBooks isAdmin isView />}
                />
                <Route
                  path="my-workspace/edit-courses/:_id"
                  element={<EditCourses />}
                />
                <Route
                  path="my-workspace/view-courses/:_id"
                  element={<EditCourses isView />}
                />
              </Route>
              <Route element={<RestrictedRoutes access={["ADMIN_REPORTS"]} />}>
                <Route path="reports" element={<Reports />} />
                <Route
                  path="reports/employee-activity"
                  element={<AdminEmployeeActivity />}
                />
                <Route
                  path="reports/company-wise-breakdown"
                  element={<AdminCompanyWiseBreakdown />}
                />
                <Route
                  path="reports/org-book-summary"
                  element={<AdminOrgBookSummary />}
                />
              </Route>
            </Route>
          </Route>
          <Route
            element={
              <PrivateRoutes
                permissions={["SUPERADMIN", "CUSTOM_ROLE", "IT"]}
                allowedLevels={true}
              />
            }
          >
            {/* Super Admin routes */}

            <Route
              path="super-admin"
              element={<MainAdminLayout isSuperAdmin />}
            >
              <Route path="" element={<SaDashboard />} />
              <Route path="account" element={<Account />} />
              <Route path="manage-quest" element={<ManageQuest />} />
              <Route
                path="manage-organization/credentials"
                element={<Credentials />}
              />
              <Route path="manage-organization/access" element={<Access />} />
              <Route
                element={<RestrictedRoutes access={["SUPERADMIN_EMPLOYEES"]} />}
              >
                <Route
                  path="manage-organization/employee"
                  element={<Employee />}
                />
                <Route
                  path="manage-organization/employee/:employeeId/activity"
                  element={<EmployeeActivityPage />}
                />
              </Route>

              <Route
                element={<RestrictedRoutes access={["SUPERADMIN_COMPANY"]} />}
              >
                <Route
                  path="manage-organization/companies"
                  element={<Companies />}
                />
                <Route
                  path="manage-organization/companies/books/:companyId"
                  element={<CompanyBooks />}
                />
              </Route>
              {/* SUPERADMIN_THEMES */}
              <Route
                element={<RestrictedRoutes access={["SUPERADMIN_THEMES"]} />}
              >
                <Route
                  path="manage-organization/themes"
                  element={<Themes refetchCurrentTheme={refetch} />}
                />
              </Route>
              {/* SUPERADMIN_Task_Verification */}
              <Route
                element={<RestrictedRoutes access={["SUPERADMIN_TASK"]} />}
              >
                <Route
                  path="manage-organization/task-verification"
                  element={<CompanyAdminTaskVerification />}
                />
                <Route
                  path="manage-organization/task-verification/time-trial/:timeTrialId"
                  element={<TimeTrialDetailed />}
                />
                <Route
                  path="manage-organization/task-verification/:_id"
                  element={<TaskDetailed />}
                />
              </Route>
              {/* Dashboard and  */}
              <Route
                element={
                  <RestrictedRoutes
                    access={["SUPERADMIN_BOOKS", "SUPERADMIN_TIMETRIAL"]}
                  />
                }
              >
                <Route
                  path="manage-organization/organizational-workspace"
                  element={<OrganizationalWorkspace />}
                />
              </Route>
              <Route
                element={<RestrictedRoutes access={["SUPERADMIN_BOOKS"]} />}
              >
                <Route
                  path="manage-organization/organizational-workspace/edit-books/:_id"
                  element={<EditBooks />}
                />
                <Route
                  path="manage-organization/organizational-workspace/view-books/:_id"
                  element={<ViewBook />}
                />
              </Route>
              <Route
                element={<RestrictedRoutes access={["SUPERADMIN_REPORTS"]} />}
              >
                <Route path="reports" element={<SaReports />} />
                <Route
                  path="reports/custom-reports"
                  element={<CustomReport />}
                />
                <Route path="reports/user-summary" element={<UserSummary />} />
                <Route
                  path="reports/employee-activity"
                  element={<EmployeeActivity />}
                />
                <Route
                  path="reports/user-statistic"
                  element={<UserStatistic />}
                />
                <Route
                  path="reports/company-wise-breakdown"
                  element={<CompanyWiseBreakdown />}
                />
                <Route
                  path="reports/org-book-summary"
                  element={<OrgBookSummary />}
                />
                <Route
                  path="reports/employee-sequential-progress"
                  element={<EmployeeSequentialProgress />}
                />
                <Route path="reports/book-summary" element={<BookSummary />} />
                <Route
                  path="reports/promotions"
                  element={<PromotionsReport />}
                />
              </Route>
              <Route
                element={<RestrictedRoutes access={["SUPERADMIN_REPORTS"]} />}
              >
                <Route path="activity-logs" element={<AdminActivityLog />} />
              </Route>
              <Route element={<ItOnlyRoute />}>
                <Route path="platform-settings" element={<PlatformSettings />}>
                  <Route index element={<Navigate to="it-users" replace />} />
                  <Route path="it-users" element={<ItUsers />} />
                </Route>
              </Route>
              <Route path="rewards" element={<Rewards />}></Route>
              <Route
                path="rewards/redeem-status"
                element={<RedeemStatus />}
              ></Route>
              <Route
                element={
                  <RestrictedRoutes access={["SUPERADMIN_PROMOTIONS"]} />
                }
              >
                <Route path="promotions" element={<Promotions />} />
                <Route
                  path="promotions/history"
                  element={<PromotionsHistory />}
                />
                <Route
                  path="promotions/history/:inviteId"
                  element={<PromotionEventDetail />}
                />
                <Route
                  path="promotions/email-templates"
                  element={<EmailTemplates />}
                />
                <Route
                  path="promotions/email-templates/:templateId"
                  element={<EmailTemplateEditor />}
                />
              </Route>
            </Route>
          </Route>
        </Route>

        {/* END OF PRIVATE ROUTES WITH AUTH */}
      </Routes>

      <Joyride
        styles={{
          options: {
            overlayColor: "rgba(0, 0, 0, 0.5)",
            primaryColor: "var(--pblue)",
            padding: "30px",
            zIndex: "1900",
          },
        }}
        steps={theme.step}
        continuous={true}
        // showProgress={true}
        showSkipButton={true}
        run={theme.tourActive}
        callback={(data) => {
          if (data.type === "tour:end") {
            handleTourEnd();
          }
        }}
        showBackButton={false}
        locale={{
          last: "End", // This sets the label for the last button to "End"
        }}
      />
    </div>
  );
}


export default App;
